<template>
    <div class="cl-radio">
        <div class="cl-radio-item" :class="{checked: val == o}" v-for="(o, i) in options" :key="i" @click="handleClick(o)">
            <div class="cl-radio-input"></div>
            <div class="cl-radio-title">{{o}}</div>
        </div>
    </div>
</template>

<script>
    import mixins from "./mixins";
    export default {
        name: "clRadio",
        model: {
            event: 'change'
        },
        mixins: [mixins],
        props: {
            value: [String, Number],
            options: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        created() {
            this.val = this.value + '';
        },
        data() {
            return {
                val: null
            }
        },
        methods: {
            handleClick(o) {
                this.val = o;
                this.$emit("change", o);
                this.notifyCheck();
            }
        }
    }
</script>

<style lang="less">
    .cl-radio-item {
        display: flex;
        align-items: center;
        &:not(:first-of-type) {
            margin-top: 12px;
        }
        &.checked {
            .cl-radio-input {
                background-color: var(--main-color);
                border-color: var(--main-color);
                color: var(--back-font-color);
                font-size: 24px;
                &::before {
                    content: '\e632';
                    font-family: fonticon;
                }
            }
        }
    }
    .cl-radio-input {
        width: 32px;
        height: 32px;
        border: var(--border);
        border-radius: 100%;
        text-align: center;
        line-height: 32px;
    }
    .cl-radio-title {
        margin-left: 20px;
        color: var(--title-font-color);
    }
</style>
